export class TrackedLink {
	trackedLinkId: number;
	createDate: string;
	lastUpdate: string;
	token: string;
	destinationUrl: string;
	trackingMode: string;
	status: string;
	sourceType: string;
	sourceName: string;
	name: string;
	description: string;
	mktgCampaignId: number;
	sourceId: number;
	tags: string;
	expiresAt: string;
	clickCount: number;
	uniqueClickCount: number;
	lastClickedAt: string;
	createdByUserId: number;
	trackingUrl: string;
	templateId: number;
	topic: number;
	topicId: number;
	recipientName: string;
	recipientEmail: string;
	recipientMobile: string;
	msgId: number;
}

export class LinkAnalytics {
	trackedLinkId: number;
	token: string;
	trackingUrl: string;
	destinationUrl: string;
	sourceType: string;
	sourceName: string;
	totalClicks: number;
	uniqueClicks: number;
	deviceBreakdown: { [key: string]: number };
	topReferers: string[];
	clicksByDay: DailyClickCount[];
	lastClickedAt: string;
	createdAt: string;

	// Summary fields
	totalLinks: number;
	activeLinks: number;
	totalClicksGlobal: number;
	uniqueClicksGlobal: number;
	clicksThisMonth: number;
	zeroClickLinks: number;

	// By source
	sourceStats: SourceStats[];

	// Top links
	topLinks: TrackedLink[];
}

export class DailyClickCount {
	date: string;
	clicks: number;
}

export class SourceStats {
	sourceType: string;
	linkCount: number;
	totalClicks: number;
	uniqueClicks: number;
}

export class LinkClick {
	appEventId: number;
	trackedLinkId: number;
	eventType: string;
	eventCategory: string;
	clickedAt: string;
	ipHash: string;
	userAgent: string;
	referer: string;
	deviceType: string;
	country: string;
	region: string;
	userId: number;
	visitorId: string;
	urlIndex: number;
}
